// extracted by mini-css-extract-plugin
export default {"sliderContainer":"hotel_page_sliderContainer__LOBsU","floatingSearchContainer":"hotel_page_floatingSearchContainer__GZ2L+"};